import axios from "axios"

export default {
	getTVRs() {
		return axios.get(`/v1/tvrs`)
	},

	getContextFeedbacks() {
		return axios.get(`/v1/context/tvr_feedbacks`)
	},

	getMyFeedbacks() {
		return axios.get(`/v1/my/tvr_feedbacks`)
	},

	getMyReceivedFeedbacks(assignmentID) {
		return axios.get(`/v1/my/received/tvr_feedbacks/${assignmentID}`)
	},

	getReceivedFeedbacks(assignmentID, recipientID) {
		return axios.get(`/v1/tvr_feedbacks/${assignmentID}/${recipientID}`)
	},

	getMyReceivedFeedbackCounts() {
		return axios.get(`/v1/my/received/tvr_feedback/counts`)
	},

	getReceivedFeedbackCounts() {
		return axios.get(`/v1/tvr_feedback/counts`)
	},

	getTVR(providerID, recipientID, assignmentID) {
		return axios.get(`/v1/tvr/${providerID}/${recipientID}/${assignmentID}`)
	},

	submitFeedback(tvr) {
		return axios.post(`/v1/tvrs`, tvr)
	},

	deleteFeedback(tvrID) {
		return axios.delete(`/v1/tvr/${tvrID}`)
	},
}